import makeDebug from 'debug'
import { TRACKER_CLICK, TRACKER_HIDDEN_ACTION } from '@/scripts/constants/tracker'
import TealiumTrackingModule from '@/scripts/libs/tracking/tealium'

const debug = makeDebug('directive:cta')

import { EVENTS, RB_BTN } from '@/scripts/constants/css-classes'

function isBtn(el) {
  return el && el.classList.contains(RB_BTN)
}

const isVideoControl = (el) => {
  return el?.parentElement.classList.contains('rb-banner__video-controls')
}

function onClickCta(event) {
  debug('click CTA %o', this.primaryCta)

  if (isBtn(event.target) && !isVideoControl(event.target)) {
    event.stopPropagation()
    return
  }

  if (isVideoControl(event.target)) {
    event.target.click()
    return
  }

  if (this.primaryCta) {
    TealiumTrackingModule.staticTrackEvent({
      event: TRACKER_CLICK,
      value: {
        Tracking_Type: TRACKER_HIDDEN_ACTION,
        data_element_id: this.primaryCta.dataset.elementId,
        data_description: this.primaryCta.dataset.description,
      },
    })
    this.primaryCta.click()
  }
}

export const GlobalCta = {
  componentUpdated: (el, binding) => {
    if (el && binding.value && !el.primaryCta) {
      let $primaryCta = el.getElementsByClassName('[data-primary-cta]')[0]

      if (!$primaryCta) {
        $primaryCta = el.querySelectorAll('.text-module__cta-container a')[0]
      }

      if ($primaryCta) {
        el.primaryCta = $primaryCta
        el.index = el.index ? el.index + 1 : 1
        debug('add global CTA %i', el.index)
        el.addEventListener(EVENTS.CLICK, onClickCta)
      }
    }
  },

  unbind: (el) => {
    debug('remove global CTA %i', el.index)
    el.removeEventListener(EVENTS.CLICK, onClickCta)
  },
}
